import { SETUPS } from '../types'
import { handleError } from '../../utils/error'
import { STATUS } from '../types'
import { changeStatus } from './status'
import Api from '../../api'
import { userSetups, setSelectedUserSetup } from './userSetups'
import { setSelectedCompareSetup } from './metrics'

export const getAllSetups = () => {
  return (dispatch, getState) => {
    return Api.Setups.getAllSetups()
      .then(res => {
        const allSetups = res.data.setups
        dispatch({ type: SETUPS.LOADED, payload: allSetups })

        // Keep userSetups in sync (only enabled setups, matching initial load)
        const permissions = getState().userPermissions.permissions
        const enabledSetups = allSetups.filter(s => s.enabled)
        const powerSetups = allSetups.filter(
          s => s.enabled && s.is_power === true,
        )
        dispatch(userSetups(enabledSetups, powerSetups, permissions))

        // Clear selectedSetup / selectedCompareSetup if they were disabled
        const key = permissions.includes('settings') ? 'name' : 'alias'
        const enabledNames = new Set(enabledSetups.map(s => s[key]))

        const currentSelected = getState().userSetups.selectedSetup
        if (currentSelected && !enabledNames.has(currentSelected)) {
          dispatch(setSelectedUserSetup(null))
        }

        const currentCompare = getState().metrics.selectedCompareSetup
        if (currentCompare && !enabledNames.has(currentCompare)) {
          dispatch(setSelectedCompareSetup(null))
        }
      })
      .catch(err => {
        handleError(dispatch, err)
      })
  }
}

export const createSetup = newSetup => {
  return (dispatch, getState) => {
    dispatch(changeStatus(STATUS.FETCHING))
    return Api.Setups.createSetup(newSetup)
      .then(() => Api.Setups.getAllSetups())
      .then(res => {
        const allSetups = res.data.setups
        const permissions = getState().userPermissions.permissions
        const enabledSetups = allSetups.filter(s => s.enabled)
        const powerSetups = allSetups.filter(
          s => s.enabled && s.is_power === true,
        )
        dispatch({ type: SETUPS.CREATED, payload: allSetups })
        dispatch(userSetups(enabledSetups, powerSetups, permissions))
        dispatch(changeStatus(STATUS.SUCCESS, 'Setup added successfully'))
      })
      .catch(err => {
        handleError(dispatch, err)
      })
  }
}

export const deleteSetup = (id, name) => {
  return (dispatch, getState) => {
    dispatch(changeStatus(STATUS.FETCHING))
    return Api.Setups.deleteSetup(id, name)
      .then(res => {
        const updatedSetups = getState().setups.filter(setup => setup.id !== id)
        const permissions = getState().userPermissions.permissions
        const enabledSetups = updatedSetups.filter(s => s.enabled)
        const powerSetups = updatedSetups.filter(
          s => s.enabled && s.is_power === true,
        )
        dispatch(userSetups(enabledSetups, powerSetups, permissions))
        dispatch({ type: SETUPS.UPDATED, payload: updatedSetups })
        dispatch(
          changeStatus(
            STATUS.SUCCESS,
            `${res.data?.msg || 'Setup deleted successfully'}: ${name}`,
          ),
        )
      })
      .catch(err => {
        handleError(dispatch, err)
      })
  }
}

export const updateSetup = updatedSetup => {
  return (dispatch, getState) => {
    dispatch(changeStatus(STATUS.FETCHING))
    return Api.Setups.updateSetup(updatedSetup)
      .then(res => {
        const updatedSetups = getState().setups.map(setup =>
          setup.id === updatedSetup.id
            ? {
                ...setup,
                id: updatedSetup.id,
                name: updatedSetup.name,
                alias: updatedSetup.alias,
                enabled: true,
              }
            : setup,
        )

        const permissions = getState().userPermissions.permissions
        const enabledSetups = updatedSetups.filter(s => s.enabled)
        const powerSetups = updatedSetups.filter(
          s => s.enabled && s.is_power === true,
        )
        dispatch(userSetups(enabledSetups, powerSetups, permissions))
        dispatch({ type: SETUPS.UPDATED, payload: updatedSetups })
        dispatch(changeStatus(STATUS.SUCCESS, res.data.msg))
      })
      .catch(err => {
        handleError(dispatch, err)
      })
  }
}
